import React from 'react'
import {productHasPurchasedPhotos} from 'lib/productHelpers'
import DownloadZipDropdown from 'components/shared/DownloadZipDropdown'

const DefaultProductStatus = ({product}) => {
  const hasPurchasedPhotos = productHasPurchasedPhotos(product)

  return (
    <div className="default-product-status">
      {!hasPurchasedPhotos && (
        <p>Produktet er bestilt, og det vil dukke opp på denne siden når det er klart. Du vil få beskjed på e-post om dette.</p>
      )}

      {hasPurchasedPhotos && (
        <>
          <p>Produktet er sendt tilbake til produksjon og vil dukke opp på denne siden når bildene er klare.</p>
          <p>Tidligere leverte bilder kan lastes ned som .zip-fil.</p>
          <DownloadZipDropdown productId={product.id} />
        </>
      )}
    </div>
  )
}

export default DefaultProductStatus
